const breakpoints = {
  xs: 320,
  mobile: 375,
  mobile_sm: 390,
  sm: 576,
  md: 768,
  lg: 992,
  '1.3lg': 1110,
  '1.5lg': 1200,
  '2lg': 1238,
  xl: 1340,
  '2xl': 1400,
};

const maxMediaQueries = {
  xs: `@media screen and (max-width: ${breakpoints.xs}px)`,
  sm: `@media screen and (max-width: ${breakpoints.sm}px)`,
  md: `@media screen and (max-width: ${breakpoints.md}px)`,
  lg: `@media screen and (max-width: ${breakpoints.lg}px)`,
  '1.5lg': `@media screen and (max-width: ${breakpoints['1.5lg']}px)`,
  '2lg': `@media screen and (max-width: ${breakpoints['2lg']}px)`,
  xl: `@media screen and (max-width: ${breakpoints.xl}px)`,
  '2xl': `@media screen and (max-width: ${breakpoints['2xl']}px)`,
  mobile: `@media screen and (max-width: ${breakpoints.mobile}px)`,
  mobile_sm: `@media screen and (max-width: ${breakpoints.mobile_sm}px)`,
};

const rounded = {
  xs: '4px',
  s: '8px',
  sm: '12px',
  m: '16px',
  l: '20px',
  xl: '24px',
  '2xl': '32px',
  rounded_10: '10px',
  rounded_20: '20px',
  rounded_24: '24px',
  rounded_30: '30px',
  rounded_40: '40px',
  rounded_50: '50px',
  circle: '50%',
};

const spacing = {
  xs: '8px',
  s: '12px',
  m: '16px',
  '2m': '21px',
  l: '24px',
  xl: '32px',
  '2xl': '48px',
  '3xl': '64px',
  '4xl': '94px',
};

const transitions = {
  fast: '0.2s ease',
  normal: '0.3s ease',
  slow: '0.4s ease',
};

const zIndex = {
  dropdown: 998,
  modal: 999,
  header: 1000,
  headerButton: 1001,
};

export const layout = { breakpoints, maxMediaQueries, rounded, spacing, transitions, zIndex };
